import type {ProvisioningStep} from '@/types/api';

const stepLabels: Partial<Record<NonNullable<ProvisioningStep>, string>> = {
    queue: 'Joining the setup queue',
    validate: 'Validating your newsletter',
    create_database: 'Creating your workspace',
    grant_permissions: 'Securing your workspace',
    create_tables: 'Preparing publication data',
    seed_fixtures: 'Adding starter content',
    seed_settings: 'Applying your settings',
    assign_plan: 'Connecting your plan',
    provision_api_credentials: 'Securing API credentials',
    activate: 'Taking your newsletter live',
    send_welcome: 'Sending your welcome email',
    timeout: 'Setup took longer than expected',
    lock_failed: 'Setup could not acquire a lock',
    unknown: 'Checking setup status'
};

function Checkmark() {
    return (
        <svg aria-hidden="true" fill="none" height="34" viewBox="0 0 40 40" width="34">
            <path d="M10 20.5 17 27l13-14" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"/>
        </svg>
    );
}

export function ProvisioningAnimation({complete, step}: {
    complete: boolean;
    step?: ProvisioningStep;
}) {
    const label = complete ? 'Newsletter ready' : (step && stepLabels[step]) || 'Preparing your newsletter';

    return (
        <div aria-label={label} className={`prov-animation ${complete ? 'is-complete' : ''}`} role="img">
            <style>{`
                .prov-animation { --prov-accent: var(--tt-accent, #ef5a2b); position: relative; display: grid; place-items: center; width: 152px; height: 104px; margin: 0 auto; color: var(--prov-accent); }
                .prov-animation span { display: block; }
                .prov-check { position: absolute; inset: 0; display: grid; place-items: center; opacity: 0; transform: scale(.65); }
                .is-complete .prov-check { opacity: 1; transform: scale(1); transition: opacity .25s ease, transform .45s cubic-bezier(.2,1.5,.4,1); }
                @keyframes prov-pulse { 50% { transform: scale(.82); opacity: .55; } }
                .prov-brand { position: relative; width: 64px; height: 64px; animation: prov-pulse 1.7s ease-in-out infinite; }
                .prov-brand span { position: absolute; width: 35px; height: 35px; border-radius: 3px 22px 3px 22px; background: var(--prov-accent); }
                .prov-brand span:nth-child(1) { left: 2px; top: 2px; }
                .prov-brand span:nth-child(2) { right: 2px; bottom: 2px; opacity: .45; }
                .is-complete .prov-brand { animation: none; opacity: .15; transform: scale(1.12); transition: all .4s ease; }
                @media (prefers-reduced-motion: reduce) { .prov-animation *, .prov-animation *::after { animation: none !important; transition-duration: 0s !important; } }
            `}</style>
            <span className="prov-brand"><span/><span/></span>
            <span className="prov-check"><Checkmark/></span>
        </div>
    );
}
